// Contactmainpage.tsx
import React, { useEffect } from "react";
import { Layout } from "antd";
import CarouselCom from "../main/components/carousel";
import Contask from "../main/components/Contask";
import Connews from "../main/components/ConNew";
import Confooter from "../main/components/Confooter";
import ConLeader from "../main/components/ConLeader";
import Conhead from "../main/components/Conhead";
import "../contactMainpage/styles/index.less"
import { useLocation } from "react-router-dom";

const { Content } = Layout;

const Contactmainpage = () => {
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem('confooterSection', 'sectioncontact');
    if (localStorage.getItem('confooterSection') === 'sectioncontact') {
      const element = document.getElementById('sectioncontact');
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);
  


  return (
    <Layout>
      <Content className="content-section-contact">
        <Conhead />
      </Content>
      <Content className="content-section-contact">
        <CarouselCom />
      </Content> 
      <Content className="content-section-contact">
        <Contask />
      </Content> 
      <Content className="content-section-contact">
        <ConLeader />
      </Content> 
      <Content className="content-section-contact">
        <Connews />
      </Content> 
      <Content className="content-section-contact" id="sectioncontact">
        <Confooter />
      </Content>
    </Layout>
  );
};

export default Contactmainpage;
